import React from "react";
import "./SubFooter.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";

const SubFooter = () => {
  const navigate = useNavigate();

  return (
    <section className="subX">
      <div className="subX__wrap">
        <div className="subX__card">
          {/* Left */}
          <div className="subX__left">
            <span className="subX__badge">Quick Growth Check</span>

            <h3 className="subX__title">
              Get a <span>free audit</span> + next steps you can apply this week
            </h3>

            <p className="subX__sub">
              Share your website + goal. We’ll review your funnel, messaging, and
              tracking — then send a short action plan with quick wins.
            </p>

            <div className="subX__points">
              <div className="pt">
                <FaCheckCircle /> Website & speed checks (mobile-first)
              </div>
              <div className="pt">
                <FaCheckCircle /> Offer + landing page improvements
              </div>
              <div className="pt">
                <FaCheckCircle /> Tracking + lead follow-up gaps
              </div>
            </div>

            <div className="subX__actions">
              <button className="btnX btnX--primary" onClick={() => navigate("/contact")}>
                Request Free Audit <FaArrowRight />
              </button>

              <button className="btnX btnX--ghost" onClick={() => navigate("/services")}>
                See What We Do
              </button>
            </div>

            <div className="subX__trust">
              <span className="chip">No pressure</span>
              <span className="chip">Actionable feedback</span>
              <span className="chip">Reply in 24h</span>
            </div>
          </div>

          {/* Right */}
          <div className="subX__right">
            <div className="subX__panel">
              <div className="panelTop">
                <span className="kicker">Before we talk</span>
                <h4>We’ll check 3 things</h4>
                <p>So the call is useful, not “intro-only”.</p>
              </div>

              <div className="panelList">
                <div className="row">
                  <span className="dot" />
                  <div>
                    <b>Traffic quality</b>
                    <span>Where users come from + intent</span>
                  </div>
                </div>

                <div className="row">
                  <span className="dot" />
                  <div>
                    <b>Conversion friction</b>
                    <span>Forms, speed, trust, clarity</span>
                  </div>
                </div>

                <div className="row">
                  <span className="dot" />
                  <div>
                    <b>Follow-up system</b>
                    <span>WhatsApp/CRM + response time</span>
                  </div>
                </div>
              </div>

              <div className="panelBottom">
                <div className="mini">
                  <span className="label">Typical response</span>
                  <b>2–8 hrs</b>
                </div>
                <div className="mini">
                  <span className="label">Best for</span>
                  <b>Brands & Startups</b>
                </div>
              </div>

              <div className="note">
                Tip: Send your website link + one goal (leads / sales / bookings) —
                we’ll reply with quick wins.
              </div>
            </div>
          </div>

          {/* deco */}
          <span className="subX__glow subX__glow1" aria-hidden="true" />
          <span className="subX__glow subX__glow2" aria-hidden="true" />
        </div>
      </div>
    </section>
  );
};

export default SubFooter;